import { Box, useToken } from "@chakra-ui/react";
import { NodeProps } from "@xyflow/react";
import { GrayScaleContext } from "features/entities/EntityCreatePage/EntityGraph/GrayScaleContext";
import InvestingHandles from "features/entities/EntityCreatePage/EntityGraph/nodes/InvestingHandles";
import { NodeLabel } from "features/entities/EntityCreatePage/EntityGraph/nodes/NodeLabel";
import { type TriangleNode as NodeType } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import { useContext } from "react";

export const TriangleNode = ({ data, id }: NodeProps<NodeType>) => {
  const token = useToken("colors", [data.backgroundColor as string]);
  const { isGrayScale } = useContext(GrayScaleContext);
  return (
    <Box>
      <Box
        style={{
          backgroundColor: "transparent",
          width: "0px",
          height: "0px",
          borderStyle: "solid",
          borderWidth: "0 108px 170px 108px",
          borderColor: `transparent transparent ${isGrayScale ? "black" : "transparent"} transparent`,
          position: "relative",
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: "5px",
            left: "-104px",
            width: "0px",
            height: "0px",
            borderStyle: "inset",
            borderWidth: "0 104px 163px 104px",
            borderColor: `transparent transparent ${isGrayScale ? "white" : token} transparent`,
            zIndex: 1,
          }}
        >
          <Box
            top="50px"
            left="-50px"
            position="relative"
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100px"
            height="110px"
          >
            <NodeLabel
              noOfLines={5}
              color={isGrayScale ? "black" : "white"}
              textAlign="center"
              margin="0px"
              label={data.label}
            />
          </Box>
        </Box>
      </Box>
      <InvestingHandles nodeId={id} />
    </Box>
  );
};
